module.exports = __webpack_public_path__ + "images/icon/add_binder-8186022b.svg";